function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "D79F0A8B-EA20-45BD-B515-3BE7A613F898@3x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Set",
  transform: "translate(-248.000000, -69.000000)",
  fill: "#160994"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Microphone_856586-Copy",
  transform: "translate(248.000000, 69.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 3.85714286,
  y: 0,
  width: 9.42857143,
  height: 16.2857143,
  rx: 4.71428571
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7140457,11.0927236 C16.7211106,10.8067919 16.5717593,10.5395213 16.3238708,10.3944887 C16.0759824,10.2494561 15.768517,10.2494561 15.5206285,10.3944887 C15.27274,10.5395213 15.1233888,10.8067919 15.1304537,11.0927236 C15.1304537,14.689249 12.1879264,17.6155258 8.57142857,17.6155258 C4.95493069,17.6155258 2.01240348,14.689249 2.01240348,11.0927236 C2.01946835,10.8067919 1.8701171,10.5395213 1.62222861,10.3944887 C1.37434011,10.2494561 1.06687479,10.2494561 0.818986293,10.3944887 C0.571097797,10.5395213 0.42174655,10.8067919 0.428811425,11.0927236 C0.428811425,15.2919973 3.66004664,18.7549483 7.77939355,19.1518686 L7.77939355,22.4251535 L4.61220944,22.4251535 C4.18248985,22.4356542 3.83963028,22.7851013 3.83963028,23.2125768 C3.83963028,23.6400522 4.18248985,23.9894993 4.61220944,24 L12.5306477,24 C12.9603673,23.9894993 13.3032269,23.6400522 13.3032269,23.2125768 C13.3032269,22.7851013 12.9603673,22.4356542 12.5306477,22.4251535 L9.36346359,22.4251535 L9.36346359,19.1513932 C13.4828105,18.754473 16.7140457,15.2919973 16.7140457,11.0927236 Z",
  id: "Path"
}))));

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "24px",
    viewBox: "0 0 17 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microphone.9d430b59.svg";
export { ForwardRef as ReactComponent };